/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CancelOperationFailureDto
 */
export interface CancelOperationFailureDto {
    /**
     * Patient ID that failed
     * @type {string}
     * @memberof CancelOperationFailureDto
     */
    patientId: string;
    /**
     * Reason for failure
     * @type {string}
     * @memberof CancelOperationFailureDto
     */
    reason: string;
}

/**
 * Check if a given object implements the CancelOperationFailureDto interface.
 */
export function instanceOfCancelOperationFailureDto(value: object): value is CancelOperationFailureDto {
    if (!('patientId' in value) || value['patientId'] === undefined) return false;
    if (!('reason' in value) || value['reason'] === undefined) return false;
    return true;
}

export function CancelOperationFailureDtoFromJSON(json: any): CancelOperationFailureDto {
    return CancelOperationFailureDtoFromJSONTyped(json, false);
}

export function CancelOperationFailureDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CancelOperationFailureDto {
    if (json == null) {
        return json;
    }
    return {
        
        'patientId': json['patientId'],
        'reason': json['reason'],
    };
}

export function CancelOperationFailureDtoToJSON(json: any): CancelOperationFailureDto {
    return CancelOperationFailureDtoToJSONTyped(json, false);
}

export function CancelOperationFailureDtoToJSONTyped(value?: CancelOperationFailureDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'patientId': value['patientId'],
        'reason': value['reason'],
    };
}

